import type { TeamId } from '../shared/index.js';

export const s = {
  name: 'Frekans',
  pitch: 'Bir ipucuyla takımını kadranda doğru noktaya getir',
  team: { a: 'Yeşil takım', b: 'Mor takım' } satisfies Record<TeamId, string>,
  teamShort: { a: 'Yeşil', b: 'Mor' } satisfies Record<TeamId, string>,
  settings: {
    readOnly: 'Ayarları oda sahibi seçer.',
    mode: 'Nasıl oynanacak',
    modeTeams: 'Takımlı',
    modeTeamsHint: 'İki takım yarışır; rakip “sağda mı, solda mı” diye tahmin eder.',
    modeCoop: 'Birlikte',
    modeCoopHint: 'Herkes tek takım; turlar bitince ortak puanınıza göre derece alırsınız.',
    teams: 'Takımlar',
    teamsHint: 'Bir oyuncuya dokunarak takımını değiştir. Takımı seçilmeyenler başlarken dağıtılır.',
    needTwo: 'Her takımda en az 2 kişi olmalı.',
    unassigned: 'Takımsız',
    shuffle: 'Karıştır',
    shuffleLabel: 'Takımları karıştır',
    empty: 'Henüz kimse yok',
    targetScore: 'Kazanmak için puan',
    rounds: 'Tur sayısı',
    seconds: 'Kadran süresi',
    secondsHint: 'İpucu verildikten sonra takımın kadranı kilitlemek için süresi. Süre bitince kadran olduğu yerde kilitlenir.',
    untimed: 'Süresiz',
    sec: (n: number) => `${n} sn`,
    cardChoice: 'Medyum kartı seçsin',
    cardChoiceHint: 'Medyum iki spektrum kartından ipucu bulmaya daha uygun olanı seçer.',
    majorityLock: 'Kilit için çoğunluk',
    majorityLockHint: 'Kapalıyken takımdan biri kilitler; açıkken takımın yarıdan fazlası onaylamalı.',
    catchUp: 'Yetişme kuralı',
    catchUpHint: 'Tam isabet (4 puan) yapan takım hâlâ gerideyse bir tur daha oynar. Birlikte modunda +1 tur kazandırır.',
    friendCards: 'Arkadaş kartları',
    friendCardsHint: 'Oyuncuların eklediği spektrumlar desteye karışır.',
    on: 'Açık',
    off: 'Kapalı',
    addCard: 'Spektrum kartı ekle',
    addCardHint: 'Zıt iki kavram yaz. Eklediğin kartlar listelenmez; oyunda sürpriz olarak çıkar.',
    left: 'Sol uç (ör. Sessiz)',
    right: 'Sağ uç (ör. Gürültülü)',
    save: 'Kartı ekle',
    saving: 'Ekleniyor…',
    saved: (l: string, r: string) => `“${l} / ${r}” desteye eklendi.`,
    failed: 'Kart eklenemedi. Biraz sonra yeniden dene.',
  },
  play: {
    you: 'sen',
    round: (done: number, total: number | null) => (total ? `Tur ${Math.min(done + 1, total)}/${total}` : `Tur ${done + 1}`),
    youTag: ' (sen)',
    toWin: (n: number) => `${n} puana ilk ulaşan kazanır`,
    total: 'Ortak puan',
    psychic: 'medyum',
    psychicIs: (nick: string) => `Medyum: ${nick}`,
    left: 'Sol',
    right: 'Sağ',
    dialLabel: 'Kadran',
    dialValue: (left: string, right: string, v: number) => `${left} ile ${right} arasında, yüzde ${Math.round(v)}`,
    // Seçim
    pickTitle: 'İpucu bulabileceğin kartı seç',
    pickHint: 'Hedef her iki kartta da aynı yerde. Seçtiğin kart herkese görünür.',
    pickWait: (nick: string) => `${nick} spektrum kartını seçiyor.`,
    // İpucu
    clueTitle: 'Hedef yeşil bölgede. Takımına bir ipucu ver.',
    clueHint: 'Bir kelime, bir isim, bir şey. Yazmak istemezsen sesli söyle ve düğmeye bas.',
    cluePlaceholder: 'İpucu (ör. Ilık süt)',
    clueSend: 'İpucunu verdim',
    clueWait: (nick: string) => `${nick} ipucunu düşünüyor.`,
    clueSpoken: 'Sesli söylendi',
    clueLabel: 'İpucu',
    targetHere: 'Hedef bu bölgede',
    dialPsychicBtn: 'Takımın kadranı çeviriyor…',
    // Kadran
    dialYou: 'İpucuna göre kadranı çevirin, sonra kilitleyin.',
    dialPsychic: 'Takımın kadranı çeviriyor. Yorum yapmak yok, yüzünü de belli etme.',
    dialOpp: (team: string) => `${team} kadranı çeviriyor. Tartışmayı dinleyin; sıra size gelecek.`,
    dialSpectator: 'Takım kadranı çeviriyor.',
    lock: 'Kadranı kilitle',
    approve: (n: number, need: number) => `Kilidi onayla (${n}/${need})`,
    unapprove: 'Onayımı geri al',
    approved: (n: number, need: number) => `Onayladın. ${need - n} onay daha gerekiyor; kadran oynarsa onaylar sıfırlanır.`,
    movedBy: (nick: string) => `Son çeviren: ${nick}`,
    // Sağ-sol
    sideTitle: 'Hedef ibrenin solunda mı, sağında mı?',
    sideHint: 'Doğru bilirseniz 1 puan. Tam isabet olduysa sayılmaz.',
    sideLeft: 'Solunda',
    sideRight: 'Sağında',
    sideWait: (team: string) => `${team} hedefin ibrenin solunda mı sağında mı olduğunu tahmin ediyor.`,
    // Açıklama
    points: (n: number) => (n === 0 ? 'Iska' : `+${n} puan`),
    bullseye: 'Tam isabet',
    sideRes: (team: string, side: string, ok: boolean) => `${team} “${side}” dedi: ${ok ? '+1 puan' : 'olmadı'}.`,
    noSide: 'Rakip tahmin yapmadı.',
    again: (team: string) => `Yetişme kuralı: ${team} bir tur daha oynuyor.`,
    againCoop: 'Tam isabet: bir tur daha kazandınız.',
    winner: (team: string) => `${team} kazandı`,
    coopDone: 'Turlar bitti',
    next: 'Sıradaki tura geç',
    toPodium: 'Sonuçlara geç',
    // Oda sahibi
    skip: 'Medyumu atla',
    skipHint: (nick: string) => `${nick} bağlı değil. Atlarsan tur puansız iptal olur ve sıradaki medyum oynar.`,
    offline: 'bağlı değil',
    history: 'Önceki turlar',
    seconds: 'sn',
  },
  ratings: ['Parazit', 'Cızırtılı yayın', 'Aynı kanaldasınız', 'Net yayın', 'Telepati'],
  ratingHint: (score: number, rounds: number) => `${rounds} turda ${score} ortak puan`,
  podium: {
    title: 'Oyun bitti',
    draw: 'Berabere',
    won: 'kazandı!',
    back: 'Lobiye dönülüyor…',
  },
  howto: {
    title: 'Nasıl oynanır',
    steps: [
      ['Kart ve hedef', 'Her turda sıradaki medyum iki zıt kavramlı bir kart ve kadranda gizli bir hedef görür. Hedefi yalnızca o bilir.'],
      ['İpucu', 'Medyum, hedefin iki uç arasındaki yerini anlatan tek bir ipucu verir. “Soğuk–Sıcak” kartında hedef ortanın biraz sağındaysa “Ilık çay” gibi.'],
      ['Kadran', 'Medyumun takımı tartışarak ibreyi çevirir ve kilitler. Takımlı modda rakip, hedefin ibrenin solunda mı sağında mı olduğunu tahmin eder.'],
      ['Puan', 'Perde açılır: tam merkez 4, yanları 3, kenarlar 2 puan. Takımlı modda hedef puana ilk ulaşan kazanır; birlikte modunda toplam puan derecenizi belirler.'],
    ] as [string, string][],
  },
};
